import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/layout/Header/CommonHeader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/layout/PageLayout.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/seo/RelatedToolsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/volume-bot/VolumeBotYouTubeEmbed.jsx");
